import { addSlideFooter } from '../helpers/slide_footer';
import { LINK_COLOR, TITLE_TEXT } from '../helpers/constants';

export const renderTextSlide = ({ footer, pptx, slide: model }) => {
  const slide = pptx.addSlide();
  slide.addText(model.title, { ...TITLE_TEXT, fontSize: 14 });
  slide.addText(model.runs || model.body, {
    align: 'left',
    color: LINK_COLOR,
    fontFace: 'Arial',
    fontSize: 14,
    h: 3.8,
    valign: 'top',
    w: '90%',
    x: 0.5,
    y: 1.1,
  });

  addSlideFooter({ ...footer, pptx, slide });
  return slide;
};
